// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Message from 'vue-m-message'

import 'vue-m-message/dist/index.css'
import '../static/style/base.css'
import './assets/style/common.less'
Vue.config.productionTip = false
Vue.use(Message)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js